import styled from "styled-components";
import { CheckboxDefault, LinkNext } from "@literati/public-ui-shared-react";
import { LINKS } from "globalConfig";
import { ReactNode } from "react";
import DLSErrorMessage from "components/DLS/DLSErrorMessage";

const StyledCheckboxDefault = styled(CheckboxDefault)`
  font-size: 0.875rem;
`;

const StyledLinkNext = styled(LinkNext)`
  position: relative;
  z-index: 3;
`;

/**
 * Legal checkbox for the email capture page.
 * Gates ability to enter the GSU portion of the funnel until a user checks the box.
 */
export const CheckoutDummyAccountLegalCheckbox = ({
  className = "",
  errorMessage = "Please agree with the terms to continue.",
  hasFieldError = false,
  onChange,
  touched = false,
}: {
  className?: string;
  errorMessage?: ReactNode;
  hasFieldError?: boolean;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  touched?: boolean;
}) => {
  return (
    <>
      <StyledCheckboxDefault
        className={`legal-checkbox-dummy-account ${className}`}
        data-testid="termsPolicy"
        name="termsPolicy"
        label={
          <>
            I agree to the{" "}
            <StyledLinkNext
              href={LINKS.terms}
              legacyBehavior={false}
              rel="noopener noreferrer"
              target="_blank"
            >
              Terms of Service
            </StyledLinkNext>{" "}
            and acknowledge the{" "}
            <StyledLinkNext
              href={LINKS.privacy}
              legacyBehavior={false}
              rel="noopener noreferrer"
              target="_blank"
            >
              Privacy Policy
            </StyledLinkNext>
          </>
        }
        onChange={onChange}
        role="checkbox"
      />
      {touched && hasFieldError ? (
        <DLSErrorMessage css="padding-left: 0" message={errorMessage} />
      ) : null}
    </>
  );
};
